import { getIascData } from '@gef-ui/features/iasc/selectors';
import { getMessage } from '@gef-ui/localization/messages';

import { history } from 'utils';

// eslint-disable-next-line import/no-cycle
import { targetPages } from './constants';
import { getTargetPage } from './selectors';

const errorRedirect =
	(errMsgs = []) =>
	(dispatch, getState) => {
		history.replace('/ias-error', {
			errMsgs,
			inputParams: {
				targetPage: getTargetPage(getState()),
				...getIascData(getState()),
			},
			canContinue: true,
		});
	};

export const bridge = () => async (dispatch, getState) => {
	const ias = getIascData(getState());
	const targetPage = getTargetPage(getState());
	if (ias && targetPage) {
		const way = targetPages[targetPage];
		if (!way) {
			dispatch(errorRedirect([getMessage('iasErrors:unknownTargetPage')]));
		} else {
			return await dispatch(way);
		}
	}
};

export { errorRedirect };
